<div class="booking-confirmation" [class.is-leaving]="leaving()">
  <!--
    Camada irmã do conteúdo: sobrevive à troca processing -> status, então consegue se dissipar
    em vez de sumir junto com o loader.
  -->
  <div class="glow-field" [class.is-active]="glowActive()" [class.is-dissipating]="glowDissipating()" aria-hidden="true">
    <div class="glow-stage">
      <span class="glow glow-a"><i class="glow-orb"></i></span>
      <span class="glow glow-b"><i class="glow-orb"></i></span>
      <span class="glow glow-c"><i class="glow-orb"></i></span>
    </div>
  </div>

  <section class="screen" role="status" aria-live="polite">
    @if (status() === 'processing') {
      <div class="processing">
        <div class="processing-loader" aria-hidden="true">
          <div class="mark">
            <svg viewBox="0 0 174.54 136.79" preserveAspectRatio="xMidYMid meet" fill="currentColor">
              <path
                d="M5.14,131.29c-3.43-3.66-5.14-8.54-5.14-14.62,0-5.13,1.47-9.6,4.4-13.41,2.94-3.8,6.89-5.71,11.88-5.71,3.82,0,6.96.6,9.41,1.78,2.45,1.19,3.67,3.78,3.67,7.77,0,1.71-.27,3.61-.8,5.71-1.6-1.43-2.98-2.4-4.14-2.92-1.16-.52-2.45-.78-3.87-.78-2.94,0-5.23,1.04-6.87,3.14-1.65,2.09-2.47,4.56-2.47,7.42,0,3.33.93,5.82,2.8,7.49,1.87,1.66,3.96,2.5,6.27,2.5,2.13,0,3.94-.45,5.4-1.36,1.47-.9,2.78-2.62,3.94-5.13,1.16-2.52,2.27-6.2,3.34-11.05L53.91,10.27c-5.96,2.57-10.59,6.51-13.88,11.84-3.29,5.33-4.94,11.79-4.94,19.4,0,3.52.31,5.97.93,7.35.62,1.38.93,2.16.93,2.35-4.8,0-8.39-1.07-10.74-3.21-2.36-2.14-3.54-5.68-3.54-10.63,0-6.08,2.33-12,7.01-17.76,4.67-5.75,10.65-10.41,17.95-13.98C54.93,2.07,62.23.29,69.52.29h5.34l-20.02,101.27c-2.31,11.7-6.14,20.49-11.48,26.39-5.34,5.89-13.21,8.84-23.62,8.84-6.32,0-11.19-1.83-14.61-5.49Z"
              />
              <path
                d="M71.79,102.55c-3.38-3.71-5.07-9.51-5.07-17.4,0-7.04,1.31-14.43,3.94-22.18,2.62-7.75,6.54-14.31,11.74-19.68,5.2-5.37,11.41-8.06,18.62-8.06,3.65,0,6.36.67,8.14,2,1.78,1.33,2.67,3.09,2.67,5.28v1l1.47-7.56h19.22l-9.61,48.49c-.36,1.43-.53,2.95-.53,4.56,0,1.9.42,3.26,1.27,4.07.84.81,2.25,1.21,4.2,1.21,1.24,0,2.22-.19,2.94-.57-1.96,5.33-3.83,9.06-5.6,11.2-1.78,2.14-4.36,3.21-7.74,3.21-3.65,0-6.61-1.16-8.87-3.49-2.27-2.33-3.67-5.58-4.2-9.77-5.43,8.84-12.06,13.26-19.88,13.26-5.07,0-9.3-1.85-12.68-5.56ZM99.75,90.93c2.18-2.23,3.67-5.3,4.47-9.2l6.41-32.23c0-1.23-.45-2.45-1.33-3.64-.89-1.19-2.27-1.78-4.14-1.78-3.56,0-6.76,2.21-9.61,6.63-2.85,4.42-5.07,9.75-6.67,15.97-1.6,6.23-2.4,11.72-2.4,16.47s.64,7.8,1.94,9.13c1.29,1.33,2.87,2,4.74,2,2.22,0,4.42-1.12,6.61-3.35ZM114.49.29h14.01l-16.15,26.96h-10.01L114.49.29Z"
              />
              <path
                d="M138.18,104.76c-2.09-2.23-3.14-4.92-3.14-8.06s1.04-5.8,3.14-7.99c2.09-2.19,4.6-3.28,7.54-3.28s5.43,1.09,7.47,3.28c2.05,2.19,3.07,4.85,3.07,7.99s-1.02,5.83-3.07,8.06c-2.05,2.24-4.54,3.35-7.47,3.35s-5.45-1.12-7.54-3.35ZM153.99,3l20.55-3-19.35,74.31h-11.34L153.99,3Z"
              />
            </svg>
          </div>
        </div>

        <h1>{{ isAccessRequest() ? 'Acessando sua conta' : 'Confirmando seu agendamento' }}</h1>
        <p>Um instante :)</p>
      </div>
    } @else {
      <div class="status-card" [class.success]="isSuccess()" [class.error]="!isSuccess()">
        <div class="status-content">
          <div class="status-visual" aria-hidden="true">
            <div class="status-orb"></div>
            <div class="status-ring"></div>

            @if (isSuccess()) {
              <svg class="status-icon" viewBox="0 0 64 64" fill="none">
                <path d="M17 33.5 27.5 44 48 22" stroke="white" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            } @else {
              <svg class="status-icon" viewBox="0 0 64 64" fill="none">
                <path d="M21 21 43 43M43 21 21 43" stroke="white" stroke-width="7" stroke-linecap="round" />
              </svg>
            }

            <span class="particle p1"></span>
            <span class="particle p2"></span>
            <span class="particle p3"></span>
            <span class="particle p4"></span>
          </div>

          <h1 class="status-title">
            @if (isSuccess()) {
              @if (isAccessRequest()) {
                Sucesso! :)
              } @else {
                {{ successTitle() }}<br />{{ successTitleLine2() }}
              }
            } @else if (errorKind() === 'session') {
              Sua sessão expirou
            } @else {
              {{ errorTitle() }}
            }
          </h1>

          <p class="status-copy">
            @if (isSuccess()) {
              {{ isAccessRequest() ? 'Seus agendamentos estão disponíveis.' : ':)' }}
            } @else if (errorKind() === 'session') {
              Toque no botão abaixo para solicitar um novo acesso.
            } @else {
              {{ errorCopy() }}
            }
          </p>

          @if (!isSuccess() && details().length) {
            <dl class="status-details">
              @for (detail of details(); track detail.label) {
                <div class="status-detail">
                  <dt>{{ detail.label }}:</dt>
                  <dd>{{ detail.value }}</dd>
                </div>
              }
            </dl>
          }

          @if (showBackButton()) {
            <button type="button" class="status-back" (click)="back.emit()">{{ backLabel() }}</button>
          }

          @if (showRequestAccessButton()) {
            <button type="button" class="status-back -access" (click)="requestAccess.emit()">Solicitar novo acesso</button>
          }
        </div>
      </div>
    }
  </section>
</div>
